var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pt-2" },
    [
      _vm.loading
        ? _c(
            "b-row",
            [
              _c("font-awesome-icon", {
                attrs: { icon: "spinner", size: "lg", spin: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading &&
      _vm.comments &&
      _vm.comments.length &&
      _vm.showTypeSelection
        ? _c(
            "b-row",
            { staticClass: "pl-0 pr-0", attrs: { "align-h": "center" } },
            [
              _c("b-col", { attrs: { cols: "8" } }, [
                _c("b", [_vm._v("Sort and display: ")]),
                _c("br"),
                _vm._v(
                  "\n      Toggle to group by and drag up/down to re-order\n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.combineDimensions,
                      expression: "combineDimensions"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.combineDimensions)
                      ? _vm._i(_vm.combineDimensions, null) > -1
                      : _vm.combineDimensions
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.combineDimensions,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.combineDimensions = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.combineDimensions = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.combineDimensions = $$c
                      }
                    }
                  }
                }),
                _vm._v(" Combine Categories\n    ")
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "draggable",
                    {
                      model: {
                        value: _vm.displayOrder,
                        callback: function($$v) {
                          _vm.displayOrder = $$v
                        },
                        expression: "displayOrder"
                      }
                    },
                    _vm._l(_vm.displayOrder, function(displayOrderItem) {
                      return _c(
                        "li",
                        {
                          key:
                            _vm.combineDimensions +
                            "-" +
                            displayOrderItem.index,
                          staticClass: "list-group-item",
                          staticStyle: { border: "0px" }
                        },
                        [
                          _c("toggle-button", {
                            attrs: {
                              labels: {
                                checked: displayOrderItem.name,
                                unchecked: displayOrderItem.name
                              },
                              width: 150,
                              height: 40,
                              "switch-color": {
                                checked: "#218838",
                                unchecked: "#aaaaaa"
                              },
                              color: {
                                checked: "#30c651",
                                unchecked: "#cccccc"
                              }
                            },
                            model: {
                              value: displayOrderItem.enabled,
                              callback: function($$v) {
                                _vm.$set(displayOrderItem, "enabled", $$v)
                              },
                              expression: "displayOrderItem.enabled"
                            }
                          })
                        ],
                        1
                      )
                    })
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.comments && _vm.comments.length
        ? _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("CommentsSection", {
                    attrs: { level: 1, comments: _vm.arrangedComments }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && (!_vm.comments || !_vm.comments.length)
        ? _c("b-row", [_vm._v("\n    No comments to display\n  ")])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3438583c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3438583c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentsList.vue
// module id = null
// module chunks = 